module.exports = __webpack_public_path__ + "img/010徐向南.b665c7f8.png";